export var CACHE_REGENERATE_TIME = 30000;